import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type FeedbackBaseFragment = { id: string, pk: number, title: string, comment: string, score: number, userName: string, timeCreated: any, url: string };

export const FeedbackBaseFragmentDoc = gql`
    fragment FeedbackBaseFragment on FeedbackType {
  id
  pk
  title
  comment
  score
  userName
  timeCreated
  url
}
    `;